<div class="row">
  <div class="col-12">
    <div class="alert" [class]="'alert-' + type()">
      @if (message()) {
        <span>{{ message() }}</span>
      }
      <ng-content></ng-content>
    </div>
  </div>
</div>
